"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { memo } from "react";
import { UseCaseHeroProps } from "./types";
import { ROUTES } from "@/constants";

const UseCaseHero = ({ content, className }: UseCaseHeroProps) => {
  const { heroTitle, heroDescription, heroImage } = content;

  const imageUrl = heroImage?.fields?.file?.url
    ? `https:${heroImage.fields.file.url}`
    : null;

  const imageDimensions = heroImage?.fields?.file?.details?.image;

  if (!heroTitle && !heroDescription && !imageUrl) {
    return null;
  }

  return (
    <section
      className={cn(
        "overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero",
        className
      )}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 pb-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[minmax(0,0.458fr)_minmax(0,0.542fr)] lg:gap-[9px] lg:py-20">
          <div className="flex flex-col lg:justify-center gap-8 lg:max-w-[496px]">
            <div className="grid grid-cols-1 gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1>{heroTitle}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{heroDescription}</p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              <Button
                asChild
                variant="primary"
                className="sm:w-[247px] h-[48px]"
              >
                <Link href={ROUTES.startOrder} className="!text-base w-full">
                  Start order
                </Link>
              </Button>
            </div>
          </div>
          {imageUrl && (
            <div className="flex items-start">
              <Image
                alt="Languex Illustration"
                src={imageUrl}
                width={imageDimensions?.width ?? 602}
                height={imageDimensions?.height ?? 512}
                className="flex-auto min-w-0"
                quality={100}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(UseCaseHero);
